import React from 'react';
import { DropdownDialog } from 'snacks-design-system';
interface componentProps {
  children?: React.ReactNode;
  toggle?: React.ReactNode;
  align?: false | 'left' | 'right' | 'center';
  padding?: false | 'small' | 'medium';
  customPosition?: { top?: number; bottom?: number; left?: number; right?: number };
  isOpen?: boolean;
  rootSelector?: string;
  modFluid?: boolean;
  modSSR?: boolean;
  modClickAway?: boolean;
  modElevation?: boolean;
  modTopOffset?: boolean;
  aria?: { label?: string; labelledby?: string; describedby?: string };
  onOpen?: () => void;
  onClose?: () => void;
  dataSctTrack?: string;
  qaSelector?: string;
}

const PIEDropdownDialog: React.FC<componentProps> = (props) => {
  return <DropdownDialog {...props} />;
};
export default PIEDropdownDialog;
